<template>
  <DefaultLayout>
    <div class="container">
      <div class="d-none d-md-block d-lg-none mt-6"></div>
      <div class="d-none d-lg-block d-xl-none" style="margin-top: 6rem;"></div>
      <div class="d-none d-xl-block d-xxl-block" style="margin-top: 6rem;"></div>
      <!-- Breadcrumbs -->
      <div style="padding-left: 30px;">
        <nav aria-label="breadcrumb">
          <ol class="py-1 my-2 breadcrumb align-middle">
            <li class="breadcrumb-item">
              <a :href="'/dashboard'" class="text-primary fw-bold">
                {{ $t('Nav.admin') }}
              </a>
            </li>
            <li class="breadcrumb-item">
              <a class="text-secondary fw-bold" style="pointer-events: none;">
                {{ $t('network.createNetwork') }}
              </a>
            </li>
          </ol>
        </nav>
      </div>
      <b-overlay :show="busy">
        <div style="padding: 0 30px;">
          <NetworkForm :form="this.networkForm" :busy="busy" :create="true" />
        </div>
      </b-overlay>
    </div>
  </DefaultLayout>
</template>
<script>
import DefaultLayout from '@/views/layouts/default/';
import NetworkForm from '@/components/forms/NetworkForm.vue';

export default {
  components: {
    DefaultLayout,
    NetworkForm,
  },
  data() {
    return {
      busy: false,
      network: null,
      networkForm: {
        name: '',
        short_name: '',
        purpose: '',
        public: true,
        default_media_permission: 'public',
        language: [],
        tags: [],
      },
    };
  },
  mounted() {
    this.$bus.on('network-submit', form => this.onSubmitEvent(form));
  },
  beforeDestroy() {
    this.$bus.off('network-submit');
  },
  methods: {
    onSubmitEvent(form) {
      this.busy = true;
      this.$http
        .post('networks/create', form)
        .then(resp => {
          if (resp.data.success) {
            var network = resp.data.network;

            this.$store.dispatch('network/resetNetworks');

            // redirects to edit form after creating network
            this.$router.push({
              name: 'networks-edit',
              params: { slug: network.slug },
            });
          } else {
            this.busy = false;
            this.$bvModal.msgBoxOk(resp.data.message);
          }
        })
        .catch(() => {
          this.busy = false;
        });
    },
  },
};
</script>
